export const newsData = [
  {
    title: "Global Leaders Reach Historic Climate Agreement at Summit",
    excerpt: "World leaders announce unprecedented joint commitment to reduce carbon emissions by 50% before 2030.",
    imageUrl: "https://images.unsplash.com/photo-1557862921-37829c790f19?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80",
    author: "Sarah Johnson",
    date: "5 hours ago",
    category: "politics"
  },
  {
    title: "Senate Passes Landmark Infrastructure Bill After Months of Negotiation",
    excerpt: "The $1.2 trillion package includes funding for roads, bridges, broadband internet, and climate initiatives.",
    imageUrl: "https://images.unsplash.com/photo-1541872703-74c5e44368f9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80",
    author: "Michael Rodriguez",
    date: "8 hours ago",
    category: "politics"
  },
  {
    title: "Supreme Court Issues Ruling on Controversial Voting Rights Case",
    excerpt: "In a 6-3 decision, the Court upheld state restrictions on ballot access, drawing criticism from civil rights groups.",
    imageUrl: "https://images.unsplash.com/photo-1589994965851-a7f82d10b7bc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80",
    author: "Jessica Chen",
    date: "1 day ago",
    category: "politics"
  },
  {
    title: "Tech Giant Announces Revolutionary AI Platform for Healthcare",
    excerpt: "The new system promises to drastically reduce diagnostic times and improve accuracy for critical conditions.",
    imageUrl: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80",
    author: "David Wilson",
    date: "3 hours ago",
    category: "technology"
  },
  {
    title: "Cybersecurity Breach Exposes Data of Millions of Users",
    excerpt: "A major social media platform confirmed that hackers accessed personal information in what experts call one of the largest breaches this year.",
    imageUrl: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80",
    author: "Alicia Washington",
    date: "12 hours ago",
    category: "technology"
  },
  {
    title: "Startup Unveils Breakthrough in Quantum Computing Technology",
    excerpt: "The new quantum processor completed calculations in minutes that would take traditional supercomputers thousands of years.",
    imageUrl: "https://images.unsplash.com/photo-1518770660439-4636190af475?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80",
    author: "Robert Kim",
    date: "1 day ago",
    category: "technology"
  },
  {
    title: "Global Markets React to Federal Reserve's Interest Rate Decision",
    excerpt: "Stock indices surged after the central bank announced it would maintain current rates despite inflation concerns.",
    imageUrl: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80",
    author: "Jennifer Taylor",
    date: "6 hours ago",
    category: "business"
  },
  {
    title: "Major Airline Announces Expansion with 50 New International Routes",
    excerpt: "The carrier's largest growth initiative in its history will create thousands of jobs and connect previously underserved markets.",
    imageUrl: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80",
    author: "Thomas Garcia",
    date: "1 day ago",
    category: "business"
  },
  {
    title: "Retail Giant to Acquire E-commerce Startup for $3.4 Billion",
    excerpt: "The acquisition signals a strategic shift as traditional retailers seek to strengthen their online presence amid changing consumer habits.",
    imageUrl: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80",
    author: "Nicole Adams",
    date: "2 days ago",
    category: "business"
  },
  {
    title: "Cultural Festival Celebrates Indigenous Art and Traditions",
    excerpt: "The annual event showcases works from over 50 indigenous communities, highlighting traditional crafts and contemporary art forms.",
    imageUrl: "https://images.unsplash.com/photo-1551913902-c92207136625?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80",
    author: "Maria Rodriguez",
    date: "2 days ago",
    category: "culture"
  },
  {
    title: "New Exhibition Explores Digital Art's Impact on Traditional Museums",
    excerpt: "The groundbreaking show examines how NFTs and digital installations are changing the landscape of art curation and preservation.",
    imageUrl: "https://images.unsplash.com/photo-1594122230689-45899d9e6f69?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80",
    author: "James Wilson",
    date: "4 days ago",
    category: "culture"
  },
  {
    title: "Humanitarian Crisis Deepens in Conflict-Affected Region",
    excerpt: "Aid organizations warn of severe food shortages and limited medical supplies as diplomatic efforts to resolve the conflict stall.",
    imageUrl: "https://images.unsplash.com/photo-1469571486292-b53601010b75?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80",
    author: "Omar Hassan",
    date: "1 day ago",
    category: "world"
  },
  {
    title: "Island Nation Implements Innovative Climate Adaptation Program",
    excerpt: "Facing rising sea levels, the country launches a comprehensive plan combining traditional knowledge with modern engineering solutions.",
    imageUrl: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80",
    author: "Leilani Mori",
    date: "3 days ago",
    category: "world"
  }
]
export const trendingNews = [
  {
    title: "Scientists Discover Potential Breakthrough Treatment for Alzheimer's Disease",
    date: "2 hours ago"
  },
  {
    title: "Global Chip Shortage Expected to Persist Through 2023, Industry Experts Warn",
    date: "4 hours ago"
  },
  {
    title: "Olympic Committee Announces New Sustainability Requirements for Future Host Cities",
    date: "6 hours ago"
  },
  {
    title: "Streaming Service Surpasses 500 Million Subscribers in Record Growth",
    date: "12 hours ago"
  },
  {
    title: "Renowned Author's New Novel Breaks First-Day Sales Records",
    date: "1 day ago"
  }
]
export const newsCategories = [
  { id: "all", name: "All News" },
  { id: "politics", name: "Politics" },
  { id: "business", name: "Business" },
  { id: "technology", name: "Technology" },
  { id: "sports", name: "Sports" },
  { id: "health", name: "Health" },
  { id: "science", name: "Science" },
  { id: "entertainment", name: "Entertainment" },
  { id: "culture", name: "Culture" },
  { id: "world", name: "World" }
]